import { Controller } from "@hotwired/stimulus"

// Logged-in-only light/dark scheme picker (dashboard Appearance).
// Applies the scheme instantly and persists it to the user's account
// (customization.medifyr_scheme) via PATCH.
export default class extends Controller {
  static values = { url: String }

  connect() {
    const current = document.documentElement.classList.contains("dark") ? "dark" : "light"
    this.reflect(current)
  }

  set(event) {
    const scheme = event.currentTarget.dataset.scheme
    if (scheme !== "light" && scheme !== "dark") return

    document.documentElement.classList.toggle("dark", scheme === "dark")
    try { localStorage.setItem("medifyr_scheme", scheme) } catch (e) {}
    this.reflect(scheme)

    if (!this.hasUrlValue) return
    const meta = document.querySelector('meta[name="csrf-token"]')
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": meta ? meta.getAttribute("content") : ""
      },
      credentials: "same-origin",
      body: JSON.stringify({ scheme })
    }).catch(() => {})
  }

  reflect(scheme) {
    this.element.querySelectorAll("[data-scheme]").forEach((btn) => {
      btn.setAttribute("aria-pressed", btn.dataset.scheme === scheme ? "true" : "false")
    })
  }
}
